export default "__VITE_ASSET__CYitquP0__"